<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead">
          <span class="prefix" v-if="component.prefix">{{ component.prefix }}</span>
          <span class="text">{{ getValue() }}</span>
          <span class="suffix" v-if="component.suffix">{{ component.suffix }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component', 'components', 'value'],
  name: 'NumberReadOnly',
  methods: {
    getValue: function () {
      if (!this.value) return '-'

      const options = { minimumFractionDigits: this.component.data.precision }
      let result = this.value.toLocaleString('en-US', options)

      const thousandSeparator = '___t___'
      const decimalSeparator = '___d___'
      const emptyString = ''

      result = result.replaceAll(',', thousandSeparator)
      result = result.replaceAll('.', decimalSeparator)

      if (this.component.data.decimal) {
        result = result.replaceAll(decimalSeparator, this.component.data.decimal)
      } else {
        result = result.replaceAll(decimalSeparator, emptyString)
      }

      if (this.component.data.thousands) {
        result = result.replaceAll(thousandSeparator, this.component.data.thousands)
      } else {
        result = result.replaceAll(thousandSeparator, emptyString)
      }

      return result
    }
  }
}
</script>
